import React, { FunctionComponent } from 'react'
import * as S from './styled'

export enum Direction {
  UP = 'UP',
  UNCHANGED = 'UNCHANGED',
  DOWN = 'DOWN',
}

const config = {
  UP: {
    angle: 0,
    color: {
      moreIsGood: '#16DB65',
      moreIsBad: '#FE5C73',
    },
  },
  UNCHANGED: {
    angle: 90,
    color: '#16DB65',
  },
  DOWN: {
    angle: 180,

    color: {
      moreIsGood: '#FE5C73',
      moreIsBad: '#16DB65',
    },
  },
}

type OwnProps = {
  direction: Direction
  showBorder?: boolean
  moreIsBad?: boolean
}

type Props = OwnProps

const ArrowIcon: FunctionComponent<Props> = ({ showBorder = false, direction, moreIsBad }) => {
  const value = moreIsBad ? 'moreIsBad' : 'moreIsGood'
  const color = config[direction].color[value]

  return <S.styledSvgIcon fill={color} rotate={config[direction].angle} border={showBorder} />
}

export default ArrowIcon
